$(document).ready(function () {
  console.log("doc ready");
  $(document).on("change", '[name="purchaseOption"]', function () {
    updateprice();
  });
  let intervl = setInterval(function () {
    // console.log($('[name="purchaseOption"]').length)
    if ($('[name="purchaseOption"]').length) {
      updateprice();
      clearInterval(intervl);
    }
  }, 100);
});
window.v = (variant) => {
  if (variant) {
    console.log(variant);
    let v = window.variants[variant.id],
      $real_pc_cp = $(".price__container .price-item--regular"),
      $real_pc_p = $(".price__container .price-item--last"),
      purchaseOption = $('[name="purchaseOption"]:checked').val();
    if (purchaseOption == "subscription") {
      $real_pc_p.html(v.rc_price_m);
      $real_pc_cp.html(v.rc_compare_at_price_m);
    } else {
      $real_pc_p.html(v.price_m);
      $real_pc_cp.html(v.compare_at_price_m);
    }
  }
};

function updateprice() {
  var purchaseOption = $('[name="purchaseOption"]:checked').val(),
    currentId = $('[name="id"]').val(),
    $real_pc_cp = $(".price__container .price-item--regular"),
    $real_pc_p = $(".price__container .price-item--last");
  $(`[var-id]`).each(function () {
    let $varid = $(this),
      id = $varid.attr("var-id"),
      $pc_p = $varid.find(".product-price-last .money"),
      $pc_cp = $varid.find(".product-price-old .money .del"),
      $pc_sp = $varid.find(".save-price .money"),
      v = window.variants[id];
    if (purchaseOption == "subscription") {
      $pc_p.html(v.rc_price_m);
      $pc_cp.html(v.rc_compare_at_price_m);
      $pc_sp.html(v.rc_save_m);
    } else {
      $pc_p.html(v.price_m);
      $pc_cp.html(v.compare_at_price_m);
      $pc_sp.html(v.save_m);
    }
  });
  let v = window.variants[currentId];
  if (purchaseOption == "subscription") {
    $real_pc_p.html(v.rc_price_m);
    $real_pc_cp.html(v.rc_compare_at_price_m);
  } else {
    $real_pc_p.html(v.price_m);
    $real_pc_cp.html(v.compare_at_price_m);
  }
}



const interval = setInterval(() => {
  const labels = document.querySelectorAll('.rc-radio__label');
  if (!labels.length) return;
  let pending = false;
  labels.forEach(label => {
    if (label.querySelector('.one-time-purchase')) return;
    const text = label.textContent;
    const index = text.indexOf('One-time purchase');
    if (index === -1) return;
    const before = text.slice(0, index);
    const oneTime = 'One-time purchase';
    const after = text.slice(index + oneTime.length);
    label.innerHTML = `
      ${before}
      <span class="one-time-purchase">${oneTime}</span>
      <span class="other-text">${after}</span>
    `;
    pending = true;
  });
  const remaining = [...labels].some(
    label =>
      label.textContent.includes('One-time purchase') &&
      !label.querySelector('.one-time-purchase')
  );
  if (!remaining) clearInterval(interval);
}, 300);